export default {"src":"/uk/_next/static/media/manage.c4fe9bf4.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};